import React from 'react';
import DataTable, {TableColumn} from 'react-data-table-component';
import Registros from './Registros';

interface RegistroTableProps {
  data: Registros[];
  columns: TableColumn<Registros>[];
  customStyles: Record<string, any>;
}

const RegistroTable: React.FC<RegistroTableProps> = ({
  data,
  columns,
  customStyles
}) => {
  return (
    <DataTable<Registros>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent="No hay registros para mostrar."
    />
  );
};

export default RegistroTable;
